import { Link } from "react-router-dom";

const CATEGORY_LINKS = [
  { name: "娱乐八卦", to: "/rank?category=yule" },
  { name: "影视综艺", to: "/rank?category=yingshi" },
  { name: "科技数码", to: "/rank?category=keji" },
  { name: "游戏电竞", to: "/rank?category=youxi" },
  { name: "社会民生", to: "/rank?category=shehui" },
  { name: "财经商业", to: "/rank?category=caijing" },
];

const PAGE_LINKS = [
  { name: "首页", to: "/" },
  { name: "热议榜单", to: "/rank" },
  { name: "关于我们", to: "/about" },
  { name: "联系我们", to: "/contact" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-950 text-background-100">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-radar-line text-xl"></i>
              </span>
              <span className="font-heading text-xl font-bold">瓜点 · 爆料雷达</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              聚合当日网络爆料、最新头条与全网热议榜单，把分散在各平台的讨论整理成一份能快速读完的热度地图。吃瓜追更，一站看全。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-2 text-xs text-background-300">
              <span className="rounded-full border border-secondary-700 px-3 py-1">每小时刷新榜单</span>
              <span className="rounded-full border border-secondary-700 px-3 py-1">多方来源交叉印证</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold tracking-wider text-background-50">
              爆料分类
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {CATEGORY_LINKS.map((c) => (
                <li key={c.to}>
                  <Link
                    to={c.to}
                    className="text-background-300 transition-colors hover:text-accent-300"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold tracking-wider text-background-50">
              网站导航
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {PAGE_LINKS.map((p) => (
                <li key={p.to}>
                  <Link
                    to={p.to}
                    className="text-background-300 transition-colors hover:text-accent-300"
                  >
                    {p.name}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="mt-5 flex items-center gap-2 text-sm text-background-300">
              <i className="ri-mail-line text-accent-400"></i>
              contact@guadian.example.com
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-secondary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center">
          <p>© 2026 瓜点 · 网络爆料雷达　内容整理自公开讨论，仅供参考。</p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="transition-colors hover:text-accent-300">
              内容原则
            </Link>
            <Link to="/contact" className="transition-colors hover:text-accent-300">
              线索投稿
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}